import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { saasRequest } from '../../saas/api';
import './MobileAuth.css';

export default function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = location.pathname.startsWith('/mobile');
  const [form, setForm] = useState({ name: '', businessName: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true); setError('');
    try {
      await saasRequest('/auth/register', { method: 'POST', body: JSON.stringify(form) });
      navigate(isMobile ? '/mobile/login' : '/login', { state: { registered: true } });
    } catch (requestError) { setError(requestError.message); } finally { setSaving(false); }
  };

  return <main className={isMobile ? 'mobile-auth' : 'min-h-screen bg-slate-100 flex items-center justify-center p-5'}>
    <form onSubmit={submit} className={isMobile ? 'mobile-auth__card space-y-4' : 'w-full max-w-md bg-white shadow-xl rounded-xl p-8 space-y-4'}>
      <div><p className={isMobile ? 'mobile-auth__eyebrow' : 'text-sm font-semibold text-primary'}>POS SaaS</p><h1 className="text-2xl font-bold">Create your business account</h1><p className={isMobile ? 'mobile-auth__help' : 'text-sm text-slate-500 mt-1'}>The platform administrator will choose your trial or approval access.</p></div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      {[['name', 'Your name', 'text'], ['businessName', 'Business name', 'text'], ['email', 'Email address', 'email'], ['password', 'Password (minimum 8 characters)', 'password']].map(([key, label, type]) => <label key={key} className="block text-sm font-medium">{label}<input required minLength={key === 'password' ? 8 : undefined} type={type} value={form[key]} onChange={(event) => setForm({ ...form, [key]: event.target.value })} className="mt-1 input input-bordered w-full" /></label>)}
      <button disabled={saving} className={isMobile ? 'mobile-auth__submit w-full' : 'btn btn-primary w-full'}>{saving ? 'Creating account…' : 'Create account'}</button>
      <p className={isMobile ? 'mobile-auth__switch' : 'text-sm text-center'}>Already have an account? <Link className="link link-primary" to={isMobile ? '/mobile/login' : '/login'}>Sign in</Link></p>
    </form>
  </main>;
}
